const ExternalLink = ({ href, children, className = "", ...props }) => {
  return (
    <a 
      href={href} 
      target="_blank" 
      rel="noreferrer" 
      className={`external-link ${className}`}
      {...props} // Allow to pass extra props like 'id' or 'aria-label'
    >
      {children}
    </a>
  );
};

export default ExternalLink;